<template>
  <v-main>
      <v-card :ripple="false" :img="ImgCover" height="240px" width="100%"></v-card>
      <v-card
        v-if="shop.length > 0"
        class="pa-2 pb-10 mt-n10"
        :color="DarkModeBackground"
        :style="
          'background-color:' +
            DarkModeBackground +
            ';min-height: 100vh;border-radius: 45px 45px 0px 0px;'
        "
      >
        <v-row>
          <v-col class="text-center">
            <v-avatar
              class="mt-n16 pa-1"
              style=""
              :color="DarkModeBackground"
              size="150"
            >
              <img :src="LoGo" />
            </v-avatar>
          </v-col>
        </v-row>

        <h3 class="text-center" :style="'color:' + DarkModefont + ';'">
          {{ languageSelect === 0 ? bookingFormHeader : bookingFormHeaderEn }}
        </h3>
        <h5
          class="text-center"
          :style="'color:' + DarkModefont + ';'"
          v-if="shop.length > 0 && shop[0].showShopName === 'True'"
        >
          {{ shop[0].shopName }}
        </h5>
        <h6
          class="text-center"
          :style="'color:' + DarkModefont + ';'"
          v-if="shop.length > 0 && shop[0].showShopName === 'True'"
        >
          {{ this.masDetail.filter(e=>e.shopId==this.shopId).length>0 ? this.masDetail.filter(e=>e.shopId==this.shopId)[0].address : '' }}
        </h6>
        <v-row align="center" class="pa-4 pl-7">
          <v-col cols="12" >
            <v-select
              v-if="branch.length > 1"
              v-model="formSelect.masBranchID"
              :label="languageSelect === 0 ? 'สาขา *' : 'Branch *'"
              dense
              outlined
              :item-text="languageSelect === 0 ? 'text' : 'textEn'"
              :items="branch"
              attach
              @change="selectBranch()"
            :menu-props="{ bottom: true, offsetY: true }"
            ></v-select>
          </v-col>
        </v-row>

        <v-tabs
          v-model="tab"
          fixed-tabs
          :color="DarkModeButton"
          class="mt-6"
        >
          <v-tab>
            <span :style="'color:' + DarkModefont + ';'">Services</span>
          </v-tab>
          <v-tab>
            <span :style="'color:' + DarkModefont + ';'">Contact</span>
          </v-tab>
        </v-tabs>

        <v-card
          v-if="tab===1"
          elevation="2"
          class="px-4 py-2 mb-2"
        >
          <v-card-text class="ml-4 my-4">
            <v-row>
              <v-col cols="12" >
                <b
                  :style="'color:' + DarkModefont + ';'"
                  v-if="shop.length > 0 && shop[0].showShopName === 'True'"
                >
                  {{ shop[0].shopName }}
                </b>
              </v-col>
              <v-col cols="12" class="mt-0 pt-0">Tel: {{ shop[0].contactTel }}</v-col>
              <v-col cols="12" class="mt-0 pt-0">Email: {{ shop[0].contactEmail }}</v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card
          v-if="tab===0"
          elevation="2"
          v-for="(flow, index) in DataFlowName" :key="`flow_${index}`"
          class="px-4 py-2 mb-2"
        >
          <v-card-text class="ml-4 mb-4 mt-4">
            <v-row>
              <v-col cols="12"><b>{{ flow.textEng }}</b></v-col>
              <v-col cols="12" sm="6" class="mt-0 pt-0">{{ flow.text }}</v-col>
              <v-col cols="12" sm="6" class="mt-0 pt-0 ml-0 pl-0 text-left text-sm-right">
                <v-btn
                  class="mx-2"
                  dark
                  :color="DarkModeButton"
                  @click="
                  shop[0].timeSlotStatus === 'True' ?
                  nextpage('CalendarBookingEmp', shopId, flow.value, flow.masBranchID):
                  nextpage('CalendarBooking', shopId, flow.value, flow.masBranchID)
                  "
                >
                  Booking
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
    </v-card>
  </v-main>
</template>

<script>
import axios from 'axios' // api
import sideMenu from '../Menu/sideMenu.vue'

export default {
  components: {
    name: '',
    sideMenu
  },
  watch: {
  },
  data () {
    return {
      languageSelect: 0,
      tab: 0,
      profile: [],
      valid: true,
      branch: [],
      shop: [],
      shopId: '',
      source: 'Shop',
      DataFlowName: [],
      DataFlowNameAll: [],
      DataflowId: '',
      flowId: '',
      branchData: [],
      ColorByShop: [],
      DarkMode: '',
      DarkModeStatus: null,
      DarkModeButton: '',
      DarkModeBackground: '',
      DarkModefont: '',
      LoGo: [],
      ImgCover: '',
      dataEmp: [],
      dataEmpAll: [],
      showMenu: 'False',
      bookingFormHeader: '',
      bookingFormHeaderEn: '',
      dataLineConfig: null,
      masBranchID: '',
      formSelect: {
        flowId: '',
        datemonth: '',
        dateday: '',
        masBranchID: ''
      },
      masDetail: [
        {
          'no.': '1',
          'shopId': 'U5f83d9e4072a371be38cd3a1d66a40f5',
          'name': 'Noeul Studio',
          'opening_date': '10 AM–8 PM\nTuesday Closed',
          'address': '39 แขวงจรเข้บัว เขตลาดพร้าว กรุงเทพมหานคร 10230',
          'Latitude': '13.841849556380309',
          'Longitude': '100.59951585767611',
          'maps': 'https://maps.app.goo.gl/qejGjdGb6STY6v976'
        },
        {
          'no.': '2',
          'shopId': 'Ucd1683126801beafb2a44f651913e58c',
          'name': 'COLORÉ STUDIO - Personal Color Analysis พัทยา ชลบุรี',
          'opening_date': '9 AM–4 PM \nMonday Closed\nTuesday Closed',
          'address': '31 12 ถ.สุขุมวิท เมืองพัทยา อำเภอบางละมุง ชลบุรี 20150',
          'Latitude': '12.983542875005671',
          'Longitude': '100.92001635889558',
          'maps': 'https://maps.app.goo.gl/phyxEgvDjba1QvwZ6'
        },
        {
          'no.': '3',
          'shopId': 'U03ef6690456719f64bb65dd29f15ab50',
          'name': 'Little Golf Sena',
          'opening_date': '10 AM–11 PM',
          'address': 'อาคารเสนาสปอร์ตพลาซ่าเซ็นเตอร์ ถ.ลาดปลาเค้า จรเข้บัว ลาดพร้าว กรุงเทพฯ 10230',
          'Latitude': '13.838650769736061',
          'Longitude': '100.59535954056952',
          'maps': 'https://maps.app.goo.gl/TZHDWLQS7k7AEbwu8'
        },
        {
          'no.': '4',
          'shopId': 'Uba49e19c644482b2b30819be08b60d3c',
          'name': 'The Angels Studio Pattaya',
          'opening_date': '10 AM–8 PM',
          'address': '225 75 เมืองพัทยา อำเภอบางละมุง ชลบุรี 20150',
          'Latitude': '12.917632961821997',
          'Longitude': '100.89286964056024',
          'maps': 'https://maps.app.goo.gl/eECTyBp5QFTuLRoA9'
        },
        {
          'no.': '5',
          'shopId': 'Ufe85a0365d39673b5c938cbc0ff89e0f',
          'name': 'ANIKA HAIR SALON',
          'opening_date': '10 AM–9 PM',
          'address': '239 (หน้าเดอะพาร์คแลนด์ ตากสิน-ท่าพระ) ถ. ตากสิน ถ.เพชรเกษม บุคคโล ธนบุรี กรุงเทพฯ 10600',
          'Latitude': '13.716930640641543',
          'Longitude': '100.48110849639058',
          'maps': 'https://maps.app.goo.gl/Nzethncn9u16t3vP9'
        },
        {
          'no.': '6',
          'shopId': 'U811d6d1b5e535c0a238da4be7527a6dd',
          'name': 'Browbabe',
          'opening_date': '9 AM–6 PM',
          'address': '21, 120 ซอย RCA แขวงบางกะปิ เขตห้วยขวาง กรุงเทพฯ 10310',
          'Latitude': '13.75009215680247',
          'Longitude': '100.57728731173302',
          'maps': 'https://maps.app.goo.gl/fgXq4XEdr6334G8Z9'
        },
        {
          'no.': '7',
          'shopId': 'U6bf55720d3b7e154b4846eac91456b70',
          'name': 'nicehair.chiangmai',
          'opening_date': '10 AM–7 PM',
          'address': '221 3 ฟ้าฮ่าม เมือง เชียงใหม่ 50000',
          'Latitude': '18.822618639024473',
          'Longitude': '99.01451152270954',
          'maps': 'https://maps.app.goo.gl/3XsotNqNG7asCAvG9'
        },
        {
          'no.': '8',
          'shopId': 'Uc83d38eca99d41e5614ba75d58b705d3',
          'name': 'JaylyLashes ร้านต่อขนตา ลิฟติ่ง lifting lashes',
          'opening_date': '10 AM–8 PM\nWednesday Closed',
          'address': 'คอนโดบ้านสวนซื่อตรง ถ.ประดิษฐ์มนูธรรม คลองเจ้าคุณสิงห์ วังทองหลาง กรุงเทพมหานคร 10310',
          'Latitude': '13.795134696927647',
          'Longitude': '100.61576882274045',
          'maps': 'https://maps.app.goo.gl/vnowSLptDWP4Bvvu6'
        },
        {
          'no.': '9',
          'shopId': 'Ubb4bade0d5be45a9385f8c403c33915d',
          'name': 'Gentleman Barber',
          'opening_date': '11 AM–8 PM',
          'address': '377 ถ.งามเมือง ตำบลเวียง อำเภอเมืองเชียงราย เชียงราย 57000',
          'Latitude': '19.90774882167804',
          'Longitude': '99.8270554756505',
          'maps': 'https://maps.app.goo.gl/3DWzbYuM5gMJ8bb66'
        },
        {
          'no.': '10',
          'shopId': 'Uf3dc570b752ea0f5d7c08d4162679756',
          'name': 'Awesome Studio Pattaya',
          'opening_date': '10 PM–12 AM',
          'address': 'เมืองพัทยา อำเภอบางละมุง ชลบุรี 20150',
          'Latitude': '12.93486614705203',
          'Longitude': '100.89302269760373',
          'maps': 'https://maps.app.goo.gl/qutiQiZgZgSBzMtPA'
        },
        {
          'no.': '11',
          'shopId': 'U2605bd37840f8dea4761d66f5d17f84e',
          'name': 'birdie•den | Swing Lounge',
          'opening_date': '8 AM–5 PM',
          'address': '398 ชั้น 3 อาคารอีโคฮับ ซอยศรีสมาน 4/1 บ้านใหม่ อำเภอปากเกร็ด นนทบุรี 11120',
          'Latitude': '13.936775381267651',
          'Longitude': '100.55148187546195',
          'maps': 'https://maps.app.goo.gl/sBRVBoCA8oxVhHLq9'
        },
        {
          'no.': '12',
          'shopId': 'U3de8c20b0e53747657b9bbd8e5613d9f',
          'name': 'Bnz.studio ต่อขนตา ลิฟขนตา',
          'opening_date': '10 AM–10 PM',
          'address': '517 75 ซอยหลวงจิต ต.ในเมือง อ.เมืองนครราชสีมา จ.นครราชสีมา 30000',
          'Latitude': '14.994201326568723',
          'Longitude': '102.0967012644177',
          'maps': 'https://maps.app.goo.gl/cEwB6MsypgAyn9QdA'
        },
        {
          'no.': '13',
          'shopId': 'U64c445c27b4d59c52a3430973a83378f',
          'name': 'TheLebLab',
          'opening_date': '10:30 AM–8 PM',
          'address': '168 ถ.เอกทักษิณ หลักหก อำเภอเมืองปทุมธานี ปทุมธานี 12000',
          'Latitude': '13.963152411810885',
          'Longitude': '100.58766241663056',
          'maps': 'https://maps.app.goo.gl/tymkm4jyVJXZuyWF8'
        },
        {
          'no.': '14',
          'shopId': 'U13af8312b10c59152271ed083d6f4910',
          'name': 'Mamind Studio',
          'opening_date': '10 AM–8 PM',
          'address': '166 5 ถ.บางกระดี่ แสมดำ บางขุนเทียน กรุงเทพฯ 10150',
          'Latitude': '13.60865286729339',
          'Longitude': '100.40354801534163',
          'maps': 'https://maps.app.goo.gl/4WwewFc2iKsCQtPZ9'
        },
        {
          'no.': '15',
          'shopId': 'U4cc81e437cffb35608ad2d2a09296258',
          'name': 'Amatio Minton | อมาติโอ มินตัน',
          'opening_date': '1 AM–8 PM',
          'address': '666 หมู่ที่ 5 คลองตำหรุ อำเภอชลบุรี จ.ชลบุรี 20000',
          'Latitude': '12.93486614705203',
          'Longitude': '100.89302269760373',
          'maps': 'https://maps.app.goo.gl/HmZmn6JWoLhVaLmt7'
        },
        {
          'no.': '16',
          'shopId': 'U4cabb94f18f7738784f613fe301fbffd',
          'name': 'Patsara Studio',
          'opening_date': '10 AM–9 PM',
          'address': '8/22 หมู่ที่ 6 อำเภอเมืองสมุทรปราการ สมุทรปราการ 10270',
          'Latitude': '13.629123561354517',
          'Longitude': '100.6134781576708',
          'maps': 'https://maps.app.goo.gl/6M5Z3k1mKgAN8Ah4A'
        },
        {
          'no.': '17',
          'shopId': 'Ua578f9c2fb5b8501468af34926821d0c',
          'name': 'storycut.hairstudio',
          'opening_date': '11 AM–8 PM',
          'address': '84 ส.วิภาวดีรังสิต 16 จอมพล จตุจักร กรุงเทพฯ 10900',
          'Latitude': '13.796845766425843',
          'Longitude': '100.5664372288354',
          'maps': 'https://maps.app.goo.gl/SWeDvR6TqqPZXAUd6'
        },
        {
          'no.': '18',
          'shopId': 'U9d9532b8db8685ea830b3aa7cf5dd854',
          'name': 'Galaxy Health & Football Club',
          'opening_date': '10 AM–11 PM\nSaturday 9 AM–11 PM\nSunday 9 AM–11 PM',
          'address': '54 54 ม.2 บางพลับ อำเภอปากเกร็ด นนทบุรี 11000',
          'Latitude': '13.917914674159157',
          'Longitude': '100.45430441534162',
          'maps': 'https://maps.app.goo.gl/Xvdds3QoPDibWPsg7'
        },
        {
          'no.': '19',
          'shopId': 'U31d74721162d663aafbf36d34efd576c',
          'name': 'Patty Beauty Salon',
          'opening_date': '9 AM–8 PM',
          'address': 'ถนนอนามัยงามเจริญ ท่าข้าม บางขุนเทียน กรุงเทพมหานคร 10150',
          'Latitude': '13.64412058213491',
          'Longitude': '100.4493018423292',
          'maps': 'https://maps.app.goo.gl/x7x8vtj7CWVDZMRZ6'
        },
        {
          'no.': '20',
          'shopId': 'U7def03a071ee547ac2f647e73d5cc5ca',
          'name': 'Love Lashes ต่อขนตา ลิฟติ้ง แว็กซ์คิ้วขอนแก่น',
          'opening_date': '        11 AM–7 PM\nTuesday 10 AM–7 PM\nWednesday Closed',
          'address': '77/10 เมือง ขอนแก่น 40000',
          'Latitude': '16.45856966297741',
          'Longitude': '102.79160433068324',
          'maps': 'https://maps.app.goo.gl/7zrknrpWFf5JexWX6'
        },
        {
          'no.': '21',
          'shopId': 'Ud3669692fa1feff1a33aff291fb9d6a0',
          'name': 'Studio Mist',
          'opening_date': '10 AM–8 PM\r\nMonday Closed',
          'address': 'โครงการ วู อยู่ที่ห้องเลขที่109ซอย255 คลองเตย วัฒนา กรุงเทพมหานคร 10110',
          'Latitude': '13.747433183836403',
          'Longitude': '100.56253583353588',
          'maps': 'https://maps.app.goo.gl/SgbvWT5ZqS3b7Uad7'
        },
        {
          'no.': '22',
          'shopId': 'U0388e17334a89faf70fe895d07280788',
          'name': 'Blackstore Barber&Tattoo',
          'opening_date': '12–10 PM',
          'address': 'บ้านเลขที่ 9 9 ซอย พหลโยธิน 53 อนุสาวรีย์ บางเขน กรุงเทพฯ 10220',
          'Latitude': '13.867765323697435',
          'Longitude': '100.59118644531144',
          'maps': 'https://maps.app.goo.gl/bcncoJW1nusdbZzz5'
        },
        {
          'no.': '23',
          'shopId': 'U8d639443c0a1de4bbfa1c4977527c7bb',
          'name': 'Daddy boy',
          'opening_date': '10 AM–8 PM',
          'address': '94 ถ.ราชพฤกษ์ บางระมาด ตลิ่งชัน กรุงเทพฯ 10170',
          'Latitude': '13.768748618954167',
          'Longitude': '100.44493175068567',
          'maps': 'https://maps.app.goo.gl/vP1niwLBzovMLZih6'
        },
        {
          'no.': '24',
          'shopId': 'Uc379fd4a3b3713fd6df2aa69d51f4a38',
          'name': 'Infinita studio',
          'opening_date': '10 AM–8 PM',
          'address': '98 ซอย ลาซาล 58 บางนาใต้ บางนา กรุงเทพมหานคร 10260',
          'Latitude': '13.655124584930109',
          'Longitude': '100.64174568639143',
          'maps': 'https://maps.app.goo.gl/tQcGfpHwwmjbcdxL8'
        },
        {
          'no.': '25',
          'shopId': 'U94a04322c8e0d19447c9871de0b04e9a',
          'name': 'Beauti nails',
          'opening_date': '12 AM–9 PM',
          'address': 'บางแสนสาย 4 เหนือ แสนสุข อำเภอเมือง ชลบุรี 20130',
          'Latitude': '13.28844443156896',
          'Longitude': '100.92752984602487',
          'maps': 'https://maps.app.goo.gl/D9pY7VMdLFhdTZQP8'
        },
        {
          'no.': '26',
          'shopId': 'U313c6e9a1a71d3cfd94ed49ceb44a5b8',
          'name': 'BetaskTestMap',
          'opening_date': '12 AM–9 PM',
          'address': '345 อำเภอปากเกร็ด นนทบุรี 11120',
          'Latitude': '13.28844443156896',
          'Longitude': '100.92752984602487',
          'maps': 'https://maps.app.goo.gl/D9pY7VMdLFhdTZQP8'
        },
        {
          'no.': '27',
          'shopId': 'Uce186fab6183b2ef27783685ea7511db',
          'name': 'bangkok lash - boutique lash & nail studio',
          'opening_date': '12 AM–9 PM',
          'address': '1 Sukhumvit Soi 18, Bangkok 10110',
          'Latitude': '13.734874',
          'Longitude': '100.55986897',
          'maps': 'https://maps.app.goo.gl/D9pY7VMdLFhdTZQP8'
        }
      ]
    }
  },
  async mounted () {
    if (this.$route.query.languageSelect) {
      this.languageSelect = parseInt(this.$route.query.languageSelect)
    }
    if (this.$route.query.shopId) {
      this.shopId = this.$route.query.shopId
      this.source = this.$route.query.source
      if (this.source !== 'CalendarBookingAutoEmpNoLine' && this.source !== 'CalendarBookingEmpNoLine' && this.source !== 'CalendarBookingNoLine') {
        this.source = 'BookingFormNoLine'
      }
      this.dataLineConfig = await this.getDataLineConfig(this.shopId)
      await this.getShop()
      await this.getDataBranch()
      await this.getDataFlow()
    }
  },
  methods: {
    toggle () {
      this.drawer = !this.drawer
    },
    nextpage (page, shopId, flowId, masBranchID) {
      window.location.assign(`https://liff.line.me/${this.dataLineConfig.liffMainID}/${page}?shopId=${shopId}&flowId=${flowId}&masBranchID=${masBranchID}&empId=1&channel=gmap`)
      // $router.push(`https://liff.line.me/this.dataLineConfig.liffMainID/CalendarBookingEmp?shopId=${shopId}&flowId=${flow.value}&masBranchID=${flow.masBranchID}&empId=1&channel=gmap`) :
      // $router.push(`https://liff.line.me/this.dataLineConfig.liffMainID/CalendarBooking?shopId=${shopId}&flowId=${flow.value}&masBranchID=${flow.masBranchID}&empId=1&channel=gmap`)
      console.log('page', page)
      console.log('this.dataLineConfig', this.dataLineConfig.liffMainID)
    },
    async getDataLineConfig (shopId) {
      let dataLineConfig = []
      // this.DNS_IP = 'https://pretest-api.betaskthai.tech'
      await axios.get(this.DNS_IP + '/lineconfig/get?shopId=' + shopId).then(response => {
        let rs = response.data
        if (rs.status === false) {
          dataLineConfig = {
            liffMainID: '1656581804-7KRQyqo5',
            liffBookingFormID: '1656581804-32mk7OgE',
            liffBookingFormEmpID: '1656581804-b09WBwkP',
            liffMainIDLoyalty: '1656906322-JN5MM8Ep',
            checkConfig: false
          }
        } else {
          dataLineConfig = rs[0]
        }
      }).catch((error) => {
        console.log(error)
        dataLineConfig = {
          liffMainID: '1656581804-7KRQyqo5',
          liffBookingFormID: '1656581804-32mk7OgE',
          liffBookingFormEmpID: '1656581804-b09WBwkP',
          liffMainIDLoyalty: '1656906322-JN5MM8Ep',
          checkConfig: false
        }
      })
      return dataLineConfig
    },
    async selectBranch () {
      this.formSelect.flowId = ''
      this.dateSelect = []
      this.showDetails = []
      await this.getDataFlow()
    },
    async getShop () {
      if (this.shopId) {
        await axios
          .get(this.DNS_IP + '/sys_shop/get?shopId=' + this.shopId)
          .then(response => {
            let rs = response.data
            if (rs.length > 0) {
              this.shop = rs
              rs.forEach(v => {
                if (v.primaryColor) {
                  this.ColorByShop.push(v.primaryColor, v.secondaryColor)
                  this.DarkModeBackground = v.primaryColor
                  this.DarkModeButton = v.secondaryColor
                } else {
                  this.ColorByShop.push('#E1F3FF', '#FFFFFF')
                  this.DarkModeBackground = '#FFFFFF'
                  this.DarkModeButton = '#E1F3FF'
                }
                if (v.shopImge) {
                  this.LoGo = v.shopImge
                } else {
                  this.LoGo = require('@/assets/LogoDefault.jpg')
                }
                if (v.shopImageCover) {
                  this.ImgCover = v.shopImageCover
                } else {
                  if (v.category === 'ธุรกิจรถยนต์') {
                    this.ImgCover = require('@/assets/Cover2.jpg')
                  } else {
                    this.ImgCover = require('@/assets/Cover2.jpg')
                  }
                }
                if (v.darkMode === 'True') {
                  this.DarkMode = '#FFFFFF'
                  this.DarkModefont = '#FFFFFF'
                  this.DarkModeStatus = true
                } else {
                  this.DarkMode = '#ffffff00'
                  this.DarkModefont = '#000000'
                  this.DarkModeStatus = false
                }
              })
            } else {
              this.shop = null
            }
            this.statusGoogleCalendar = rs[0].statusGoogleCalendar
            this.statusGoogleCalendarEmp = rs[0].statusGoogleCalendarEmp
            console.log('this.shop ', this.shop)
          })
      } else {
        this.ColorByShop.push('#E1F3FF', '#FFFFFF')
        this.DarkMode = '#ffffff00'
        this.DarkModefont = '#173053'
      }
    },
    async getDataFlow () {
      this.DataFlowName = []
      this.DataFlowNameAll = []
      let dataFlowName = []
      let dataFlowNameAll = []
      // console.log('DataFlowName', this.DataFlowName)
      await axios.get(this.DNS_IP + '/flow/get?shopId=' + this.shopId).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            if (d.masBranchID === this.formSelect.masBranchID.toString() || d.masBranchID === 'All') {
            // if (d.timeSlotStatus === 'True') {
              let s = {}
              s.text = d.flowName
              s.textEng = d.flowNameEn
              s.value = d.flowId
              s.masBranchID = this.formSelect.masBranchID.toString()
              dataFlowName.push(s)
              dataFlowNameAll.push(d)
              // }
            }
            // console.log('dataFlowName', dataFlowName)
          }
          this.DataFlowName = dataFlowName
          this.DataFlowNameAll = dataFlowNameAll
          if (this.DataFlowName.length === 1) {
            this.flowId = this.DataFlowName[0].value
          }
        } else {
          this.DataFlowName = []
          this.DataFlowNameAll = []
        }
      })
    },
    async getEmp () {
      this.fromAdd.empId = ''
      this.dataEmp = []
      this.dataEmpAll = []
      this.EmpItemLimit = []
      try {
        const response = await axios.get(this.DNS_IP + '/empSelect/get?privacyPage=bookingform')
        const rs = response.data
        if (rs.length > 0) {
          for (let i = 0; i < rs.length; i++) {
            let d = rs[i]
            if (d.flowId !== null && d.flowId !== '') {
              let checkFlowId = JSON.parse(d.flowId)
              if (checkFlowId.filter((a) => parseInt(a) === this.flowId).length > 0) {
                if (d.setTime !== null && d.setTime !== '[]' && d.setTime !== '') {
                  let s = {}
                  s.text = d.empFull_NameTH
                  s.textEng = d.empFull_NameTH
                  s.value = d.empId
                  this.dataEmp.push(s)
                  this.dataEmpAll.push(d)
                  let limit = {}
                  limit.empId = d.empId
                  limit.limitBookingCheck = d.limitBookingCheck || 'False'
                  limit.setTime = d.setTime || '[]'
                  limit.setTimebyday = d.setTimebyday
                  this.EmpItemLimit.push(limit)
                  console.log('EmpItemLimit', this.EmpItemLimit)
                }
              }
            }
          }
        } else {
          this.dataEmp = []
          this.dataEmpAll = []
          this.EmpItemLimit = []
        }
        await this.checkEmpData()
      } catch (error) {
        console.error('Error fetching employee data:', error)
      }
    },
    async getDataBranch () {
      this.branch = []
      this.branchData = []
      await axios.get(this.DNS_IP + '/master_branch/get?shopId=' + this.shopId).then(response => {
        let rs = response.data
        console.log('rs', rs)
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            let s = {}
            s.text = d.masBranchName
            s.textEng = d.masBranchNameEn
            s.value = d.masBranchID
            this.branch.push(s)
            this.branchData.push(d)
            // console.log('dtdtdtdt', this.branch)
          }
        }
      })
      // console.log('branchData', this.branchData)
      if (this.branch.length > 0) {
        this.formSelect.masBranchID = this.branch[0].value
      }
    }
  }
}
</script>

<style scoped>
.textPriceMenu {
/* Price/Small */
font-style: normal;
font-weight: 700;
font-size: 14px;
line-height: 20px;

color: #FF7B2C;

}
.textTitelPriceMenu {
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 22px;
}
.textTitelMenu {
font-style: normal;
font-weight: 600;
font-size: 12px;
line-height: 22px;
width:100%;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
}
.textTitelMenuSub {
font-style: normal;
font-weight: 600;
font-size: 12px;
line-height: 22px;
}
.textTitelMenuRemark {
font-style: normal;
font-weight: 400;
font-size: 11px;
line-height: 22px;
width:100%;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
}
.textSubTitelMenu {
font-style: normal;
font-weight: 200;
font-size: 14px;
line-height: 22px;
}
.cardTextMenu {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 15px;

  width: 147px;
  height: 104px;
  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 1;
}
.pictureMenu {
  width: 40px;
  height: 40px;

  filter: drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.7));

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.cardMenu {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 12px;
  gap: 12px;

  width: 327px;
  height: 70px;

  background: #FFFFFF;
  box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.03), 0px 4px 20px -2px rgba(50, 50, 71, 0.04);
  border-radius: 16px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 1;
}
.slidein {
  width: 100%;
  padding: 2em 1em;
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  background: #fff;
  height: 100%;
  overflow: scroll;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
  transition: all 0.5s ease-in-out;
}
.roundDialog {
  border-radius: 30px;
}
.button {
  width: 45%;
  color: #fff;
  font-weight: 200;
  letter-spacing: 1px;
  margin: 6px 3px;
  padding: 10px 28px;
  border-radius: 25px !important;
  background-color: #0047a5;
}
.portrait.v-card {
  margin: 0 auto;
  max-width: 600px;
  width: 100%;
}
.main {
  padding: 0px;
  background: #ffffff;
}
.content {
  border-radius: 10px;
}
.a {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0px;
}
.InputData {
  margin: 0px !important;
  padding: 0px !important;
}
.custom-checkbox >>> .v-label {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Booking/Shop.vue